import { Link } from "react-router-dom"; 

const prompts = [

  {
    id: "us_list",
    title: "米国の企業をリストアップする",
    prompt: `insight noteの自然言語技術を使い米国の有価証券報告書から企業をリストアップすることができます。
    これで自社と同じ業界の米国での事例を研究することができます。`,
    output: `米国のXX業界の企業をリストアップして。`,
    largeCategory: "分析",
    middleCategory: ["企業分析"],
    date: "2024-01-17",
  },
  {
    id: "recruiting",
    title: "採用戦略を立てる",
    prompt: `有価証券報告書の内容を分析させ成長のために必要な人材について考えさせるプロンプトです。
    採用戦略を立てる時などに使えます。`,
    output: `A社が今後取るべき戦略を考察してください。またそれに必要な人材はどのような人材ですか？`,
    largeCategory: "職種別",
    middleCategory: ["人事"],
    date: "2024-01-16",
  },
  {
    id: "Sales_for_Banker",
    title: "証券営業で使えるプロンプト",
    prompt: `有価証券報告書を搭載したinsight noteでは証券営業のトークを考えるのに適しています。
    競合との差異や今後の戦略を分析させましょう。`,
    output: `あなたは証券営業マンです。
    A社の株を販売するために、有報を分析し、セールストークを考えてください`,
    largeCategory: "職種別",
    middleCategory: ["営業"],
    date: "2024-01-15",
  },
  {
    id: "Sales",
    title: "営業に使えるプロンプト",
    prompt: `有価証券報告書には企業の戦略や課題が記載されています。
    このような背景知識を理解した上で営業をすることで本質的な提案が可能となります。`,
    output: `当社はXXという商品を扱っています。
    [顧客名]の有価証券報告書から、課題や戦略を要約してください。
    そして当社のサービスを提案する原稿を作成してください。`,
    largeCategory: "職種別",
    middleCategory: ["営業"],
    date: "2024-01-14",
  },
  {
    id: "Investor_Relation",
    title: "IR担当者が投資家からの質問に備える。",
    prompt: `過去の有価証券の内容を分析し、投資家から想定される質問をAI にリストアップさせることができます。`,
    output: `あなたは企業AのIR担当者です。
    有価証券報告書に基づき、投資家から想定される質問をリストアップしてください。
    それぞれの質問に対する適切な回答案も用意してください。`,
    largeCategory: "職種別",
    middleCategory: ["IR"],
    date: "2024-01-13",
  },
  {
    id: "Natural_Sentence",
    title: "自然な日本語で回答させるプロンプト",
    prompt: `AIの文章がやや不自然なことがあります。
    そのため記事を制作するときなどは、自分で修正する必要があります。
    そういった時は「だ、である調で」や「文末表現をなくして」や「句構造文法で」と伝えてみましょう。`,
    output: `A社の直近の有価証券報告書の内容をもとに記事を作成してください。
    文末表現をなくしてください。`,
    largeCategory: "職種別",
    middleCategory: ["記事制作"],
    date: "2024-01-12",
  },
  {
    id: "Order_Output",
    title: "出力形式を指定するプロンプト",
    prompt: `回答フォーマットを指定することができます。
    例えば、企業の財務諸表を知りたいとき、それを表形式で回答して欲しいのかグラフで回答して欲しいのかといったものです。`,
    output: `A社とB社が仮に合併したとき、C社との財務状況を分析したい。
    下記の項目を表でまとめて。
    1.売上高
    2.営業利益
    3.税引前利益
    4.当期純利益
    5.販売台数
    `,
    largeCategory: "コツ",
    middleCategory: ["中級"],
    date: "2025-01-11",
  },
  {
    id: "Deep_Think",
    title: "AIによく考えさせるプロンプト",
    prompt: `プロンプトの単語1つでAIの回答は大きく変わってきます。
    AIはとても忠実にあなたの指示を聞いてくれているということですね。
    例えば、AIに深く考えてから回答をして欲しい時は『深呼吸して』と付け加えてみてください。
    より慎重に回答をしてくれます。`,
    output: `深呼吸して、A社とB社の決算書を比較分析し得られた洞察を教えてください。`,
    largeCategory: "コツ",
    middleCategory: ["初級"],
    date: "2025-01-06",
  },
  {
    id: "Name_Analysis",
    title: "AIを専門家にする",
    prompt: `AIはネットの膨大な知識を学習しています。
    あなたが〇〇の専門家になりきってというとAIはその専門家の知識を披露してくれます。`,
    output: `あなたは、優秀な企業コンサルタントです。
    A社の業績を改善するためのアイデアを考えてください。`,
    largeCategory: "コツ",
    middleCategory: ["初級"],
    date: "2025-01-06",
  },
  {
    id: "Step_by_Step",
    title: "複雑なタスクを実行させる",
    prompt: `
    AIはとても素早く回答してくれますが、一方で依頼したタスクに漏れがあることがあります。
    タスクを依頼するときは『ステップバイステップで』という単語を加えてみてください。
    そうすると与えられた依頼を分割し順番に1つ1つ実行してくれます。
    また、さらにミスを減らすには、依頼する前に、タスクを分割してあげましょう。
    そうすることでAIは自分が何をすれば正しい回答ができるか理解してくれます。`,
    output: `A社とB社の合併後の財務状況が知りたい。
    下記のタスクをステップバイステップで実行してください。
    1.A社とB社の2024年度の有価証券報告書から売上、利益、販売台数をリストアップする。
    2.両社が合併した時の合計を算出する。`,
    largeCategory: "コツ",
    middleCategory: ["中級"],
    date: "2025-01-06",
  },
  {
    id: "Swot_Analysis",
    title: "SWOT分析をする",
    prompt: `このプロンプトは、SWOT分析を通じて企業理解を深めるためのものです。
      SWOT分析は、ビジネスやプロジェクトの内部環境（強みと弱み）と外部環境（機会と脅威）を評価するフレームワークです。
      企業理解を素早く把握したいときに有効です。`,
    output: `A社の事業についての理解を深めるため、SWOT分析を実施してください。`,
    largeCategory: "分析",
    middleCategory: ["企業分析"],
    date: "2025-01-06",
  },
  {
    id: "AI_Debate",
    title: "AI同士で議論",
    prompt: `AIエージェント2体が将来の可能性について多角的な議論を行うものです。
      一方は議題に対して肯定的で、一方は否定的です。
      これにより多角的な分析を行うことができます。
      これは孫正義さんが実際にアイデアを考える際に使っている手法として有名なものです。
      将来の事業など正解がわからないものを考える際に、思ってもない視点を発見することができるかもしれません。`,
    output: `A社のの有価証券報告書を基に、AとBのアナリストが将来の収益についての可能性を議論します。
    Aは文書の内容を楽観的に解釈し、将来のポジティブな展望について議論します。
    一方、Bは文書の内容を悲観的に見て、潜在的な課題やリスクについて議論します。
    AとBは互いの主張に必ず1度反論し、反論には追加の根拠を提示すること`,
    largeCategory: "分析",
    middleCategory: ["企業分析"],
    date: "2025-01-06",
  },
  {
    id: "biginner",
    title: "小学生にもわかるように",
    prompt: `企業分析に慣れていない人にとって決算書の内容を理解するのはとても大変です。
    『初心者向けに』、『小学生でもわかるように』といったフレーズを加えることで簡単な単語で説明してくれます。`,
    output: `A社を例に、決算書分析のやり方についてを初学者向けに解説して`,
    largeCategory: "コツ",
    middleCategory: ["初級"],
    date: "2025-01-10",
  },
];

export default prompts;




